import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import errorImg from '@src/assets/images/pages/error.svg'
import '@styles/base/pages/page-misc.scss'
import { useTranslation } from 'react-i18next';
import '../../utility/I18n'
import { STRINGS } from '@helpers/strings';
import {
  isClient,
  isManager,
} from "@services/authentificationServices";


const Error = () => {
  const { t } = useTranslation();
  const courceLogo = require(`@src/assets/images/logo/logo VJ_#d91d0b_1 1.png`).default
  const homePageLink = isClient() || isManager() ? "/creer-une-annonce" : "/"
  return (
    <div className='misc-wrapper'>
      <a className='brand-logo' href={homePageLink}>
      </a>
      <div className='misc-inner p-2 p-sm-3'>
        <div className='w-100 text-center'>
        <img className='img-fluid' src={courceLogo} alt='Login V2' />
          <h2 className='mb-1'>{t('page_not_found')} 🕵🏻‍♀️</h2>
          <p className='mb-2'>{t('whoops')} 😖 {t('page_not_found_2')}</p>
          <Button.Ripple tag={Link} to={homePageLink} color={STRINGS.COLORS.PRIMARY} className='btn-sm-block mb-2'>
            {t('return_home')}
          </Button.Ripple>
          <img className='img-fluid' src={errorImg} alt='Not authorized page' />
        </div>
      </div>
    </div>
  )
}
export default Error
